import { render, staticRenderFns } from "./VrTestResultDetails.vue?vue&type=template&id=69001a20&"
import script from "./VrTestResultDetails.vue?vue&type=script&lang=js&"
export * from "./VrTestResultDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports